(function() {
    'use strict';

    angular.module('allegro', [
            'ui.router',
            'allegro.services',
            'allegro.constants'
        ])
        .config(uiRouting);

    uiRouting.$inject = [
        '$stateProvider',
        'userPermissionsConst',
        'allegroAccountPermissionsConst',
        'allegroConfigPermissionsConst',
        'allegroSellerPermissionsConst',
        'allegroSenderPermissionsConst',
        'allegroCodReceiverPermissionsConst',
        'allegroResponsibleProducerPermissionsConst',
        'allegroSafetyInformationPermissionsConst',
        'allegroOfferPermissionsConst',
        'allegroThreadPermissionsConst'
    ];

    function uiRouting(
        $stateProvider,
        userPermissionsConst,
        allegroAccountPermissionsConst,
        allegroConfigPermissionsConst,
        allegroSellerPermissionsConst,
        allegroSenderPermissionsConst,
        allegroCodReceiverPermissionsConst,
        allegroResponsibleProducerPermissionsConst,
        allegroSafetyInformationPermissionsConst,
        allegroOfferPermissionsConst,
        allegroThreadPermissionsConst
    ) {
        $stateProvider
            .state('layout.allegro-accounts', {
                abstract: true,
                url: '/allegro/accounts',
                data: {
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.allegro-accounts.list', {
                url: '/list',
                views: {
                    'main@layout': {
                        templateUrl: 'app/allegro/views/account-list/account-list.html',
                        controller: 'AccountListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    title: 'Allegro - Moje Konta',
                    modelPermission: allegroAccountPermissionsConst.view
                }
            })
            .state('layout.allegro-accounts.create', {
                url: '/create',
                views: {
                    'main@layout': {
                        templateUrl: 'app/allegro/views/account-create/account-create.html',
                        controller: 'AccountCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    title: 'Allegro - Nowe konto',
                    modelPermission: allegroAccountPermissionsConst.add
                }
            })
            .state('layout.allegro-accounts.update', {
                url: '/:pk/update',
                views: {
                    'main@layout': {
                        templateUrl: 'app/allegro/views/account-update/account-update.html',
                        controller: 'AccountUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    title: 'Allegro - Edycja konta',
                    modelPermission: allegroAccountPermissionsConst.update
                }
            })
            .state('layout.allegro-accounts.oauth-create', {
                url: '/:pk/oauth-create',
                views: {
                    'main@layout': {
                        templateUrl: 'app/allegro/views/oauth-create/oauth-create.html',
                        controller: 'AllegroOauthCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    title: 'Allegro - Dodaj OAuth',
                    modelPermission: allegroConfigPermissionsConst.add
                }
            })
            .state('layout.allegro-accounts.offers-create', {
                url: '/:pk/offer-create',
                views: {
                    'main@layout': {
                        templateUrl: 'app/allegro/views/offer-create/offer-create.html',
                        controller: 'AllegroOfferCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    title: 'Allegro - Nowa oferta',
                    modelPermission: allegroOfferPermissionsConst.add
                }
            })
            .state('layout.allegro-accounts.seller-create', {
                url: '/:pk/seller-create',
                views: {
                    'main@layout': {
                        templateUrl: 'app/allegro/views/seller-create/seller-create.html',
                        controller: 'AllegroSellerCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    title: 'Allegro - Dodaj sprzedawcę',
                    modelPermission: allegroSellerPermissionsConst.add
                }
            })
            .state('layout.allegro-accounts.sender-create', {
                url: '/:pk/sender-create',
                views: {
                    'main@layout': {
                        templateUrl: 'app/allegro/views/sender-create/sender-create.html',
                        controller: 'AllegroSenderCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    title: 'Allegro - Dodaj nadawce',
                    modelPermission: allegroSenderPermissionsConst.add
                }
            })
            .state('layout.allegro-accounts.cod-receiver-create', {
                url: '/:pk/cod-receiver-create',
                views: {
                    'main@layout': {
                        templateUrl: 'app/allegro/views/cod-receivers-create/cod-receivers-create.html',
                        controller: 'AllegroCodReceiverCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    title: 'Allegro - Dodaj odbiorcę przelewu',
                    modelPermission: allegroCodReceiverPermissionsConst.add
                }
            })
            .state('layout.allegro-accounts.responsible-producer-create', {
                url: '/:pk/responsible-producer-create',
                views: {
                    'main@layout': {
                        templateUrl: 'app/allegro/views/responsible-producer-create/responsible-producer-create.html',
                        controller: 'AllegroResponsibleProducerCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    title: 'Allegro - Dodaj osobę odpowiedzialną',
                    modelPermission: allegroResponsibleProducerPermissionsConst.add
                }
            })
            .state('layout.allegro-accounts.safety-information-create', {
                url: '/:pk/safety-information-create',
                views: {
                    'main@layout': {
                        templateUrl: 'app/allegro/views/safety-information-create/safety-information-create.html',
                        controller: 'AllegroSafetyInfoCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    title: 'Allegro - Dodaj informację o bezpieczeństwie produktu',
                    modelPermission: allegroSafetyInformationPermissionsConst.add
                }
            })
            .state('layout.allegro-accounts.detail', {
                abstract: true,
                url: '/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/allegro/views/account-detail/account-detail.html',
                        controller: 'AccountDetailController',
                        controllerAs: 'ctrl'
                    }
                }
            })
            .state('layout.allegro-accounts.detail.overview', {
                url: '/overview',
                templateUrl: 'app/allegro/views/account-overview/account-overview.html',
                controller: 'AccountOverviewController',
                controllerAs: 'ctrl',
                data: {
                    title: 'Allegro - Podgląd konta',
                    modelPermission: allegroAccountPermissionsConst.view
                }
            })
            .state('layout.allegro-accounts.detail.settings', {
                url: '/settings',
                templateUrl: 'app/allegro/views/account-settings/account-settings.html',
                controller: 'AccountSettingsController',
                controllerAs: 'ctrl',
                data: {
                    title: 'Allegro - Ustawienia',
                    modelPermission: allegroAccountPermissionsConst.view
                }
            })
            .state('layout.allegro-accounts.detail.offers', {
                url: '/offers',
                templateUrl: 'app/allegro/views/account-offers/account-offers.html',
                controller: 'AccountOffersController',
                controllerAs: 'ctrl',
                data: {
                    title: 'Allegro - Oferty',
                    modelPermission: allegroOfferPermissionsConst.view
                }
            })
            .state('layout.allegro-accounts.detail.threads', {
                url: '/threads',
                templateUrl: 'app/allegro/views/account-threads/account-threads.html',
                controller: 'AccountThreadsController',
                controllerAs: 'ctrl',
                data: {
                    title: 'Allegro - Wiadomości',
                    modelPermission: allegroThreadPermissionsConst.view
                }
            });

        $stateProvider
            .state('layout.allegro-oauth', {
                abstract: true,
                url: '/allegro/oauth',
                data: {
                    title: 'Allegro - Ustawienia OAuth',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.allegro-oauth.update', {
                url: '/:pk/update',
                views: {
                    'main@layout': {
                        templateUrl: 'app/allegro/views/oauth-update/oauth-update.html',
                        controller: 'AllegroOauthUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    title: 'Allegro - Edytuj OAuth',
                    modelPermission: allegroConfigPermissionsConst.update
                }
            });

        $stateProvider
            .state('layout.allegro-sellers', {
                abstract: true,
                url: '/allegro/sellers',
                data: {
                    title: 'Allegro - Dane sprzedawcy',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.allegro-sellers.update', {
                url: '/:pk/update',
                views: {
                    'main@layout': {
                        templateUrl: 'app/allegro/views/seller-update/seller-update.html',
                        controller: 'AllegroSellerUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    title: 'Allegro - Edytuj sprzedawcę',
                    modelPermission: allegroSellerPermissionsConst.update
                }
            });

        $stateProvider
            .state('layout.allegro-senders', {
                abstract: true,
                url: '/allegro/senders',
                data: {
                    title: 'Allegro - Dane nadawcy',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.allegro-senders.update', {
                url: '/:pk/update',
                views: {
                    'main@layout': {
                        templateUrl: 'app/allegro/views/sender-update/sender-update.html',
                        controller: 'AllegroSenderUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    title: 'Allegro - Edytuj nadawce',
                    modelPermission: allegroSenderPermissionsConst.update
                }
            });


        $stateProvider
            .state('layout.allegro-cod-receivers', {
                abstract: true,
                url: '/allegro/cod-receivers',
                data: {
                    title: 'Allegro - Dane odbiorcy przelewu',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.allegro-cod-receivers.update', {
                url: '/:pk/update',
                views: {
                    'main@layout': {
                        templateUrl: 'app/allegro/views/cod-receivers-update/cod-receivers-update.html',
                        controller: 'AllegroCodReceiverUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    title: 'Allegro - Edytuj odbiorce przelewu',
                    modelPermission: allegroCodReceiverPermissionsConst.update
                }
            });

        $stateProvider
            .state('layout.allegro-responsible-producers', {
                abstract: true,
                url: '/allegro/responsible-producers',
                data: {
                    title: 'Allegro - Dane osoby odpowiedzialnej',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.allegro-responsible-producers.update', {
                url: '/:pk/update',
                views: {
                    'main@layout': {
                        templateUrl: 'app/allegro/views/responsible-producer-update/responsible-producer-update.html',
                        controller: 'AllegroResponsibleProducerUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    title: 'Allegro - Edytuj osobę odpowiedzialną',
                    modelPermission: allegroResponsibleProducerPermissionsConst.update
                }
            });

        $stateProvider
            .state('layout.allegro-safety-informations', {
                abstract: true,
                url: '/allegro/product-safety-informations',
                data: {
                    title: 'Allegro - Informację o bezpieczeństwie produktu',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.allegro-safety-informations.update', {
                url: '/:pk/update',
                views: {
                    'main@layout': {
                        templateUrl: 'app/allegro/views/safety-information-update/safety-information-update.html',
                        controller: 'AllegroSafetyInfoUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    title: 'Allegro - informację o bezpieczeństwie produktu',
                    modelPermission: allegroSafetyInformationPermissionsConst.update
                }
            });

        $stateProvider
            .state('layout.allegro-offers', {
                abstract: true,
                url: '/allegro/offers',
                data: {
                    title: 'Oferty',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.allegro-offers.update', {
                url: '/:pk/update',
                views: {
                    'main@layout': {
                        templateUrl: 'app/allegro/views/offer-update/offer-update.html',
                        controller: 'AllegroOfferUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: allegroOfferPermissionsConst.update
                }
            });

        $stateProvider
            .state('layout.allegro-threads', {
                abstract: true,
                url: '/allegro/threads',
                data: {
                    title: 'Allegro - Wiadomości',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.allegro-threads.details', {
                url: '/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/allegro/views/thread-details/thread-details.html',
                        controller: 'AllegroThreadDetailsController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: allegroThreadPermissionsConst.view
                }
            });
    }
})();
